import highlightsData from '../content/highlights.json'

export default function HighlightsSection() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Key Insights</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Powerful quotes and concepts from the book that challenge conventional thinking
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {highlightsData.map((highlight) => (
            <div key={highlight.id} className="bg-white rounded-lg shadow-lg p-6">
              {highlight.image && (
                <img 
                  src={highlight.image} 
                  alt={`Illustration for ${highlight.title}`} 
                  className="w-full h-56 object-cover object-top rounded mb-4"
                />
              )}
              <div className="mb-3">
                <span className="inline-block bg-primary-100 text-primary-800 text-xs font-semibold px-2 py-1 rounded">
                  {highlight.category}
                </span>
              </div>
              <h3 className="text-lg font-semibold mb-3">{highlight.title}</h3>
              <blockquote className="text-gray-700 italic mb-4">
                "{highlight.content}"
              </blockquote>
              <p className="text-sm text-gray-500">
                — {highlight.chapter}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}